import { BILLING_CYCLE, defaultBillingCycle, defaultPlanCategory } from '../constant';
import isPlainObject from "lodash-es/isPlainObject";

const shouldImplement = (flow) => {
  throw new Error(`Flow::${flow} should be implemented`);
};

export class FlowInterface {
  /**
   *
   * @param productEntryData {ProductEntryDataBean}
   * @param options {FlowProductEntryOptionsParams}
   */
  constructor(productEntryData, options) {
    this.productEntryData = productEntryData;
    this.options = options;
    this.flowType = options?.flowType;
    this.basePlan = options?.basePlan ?? defaultPlanCategory;
    this.planType = options?.planType;
    this.eventTrackItemInfo = isPlainObject(options?.eventTrackItemInfo) ? options?.eventTrackItemInfo : {};
    // period priority ---> backend api -> component option -> default
    this.period = BILLING_CYCLE[productEntryData?.billingCycle] || options?.period || defaultBillingCycle;
    this.campaignCode = productEntryData?.campaignCode;
    this.capacity = productEntryData?.capacity;
    this.trialCode = productEntryData?.trialCode;
    this.serviceCategoryCode = productEntryData?.categoryCode;
  }

  getBuyNowParams() {
    return {
      ...this.eventTrackItemInfo,
      type: this.flowType,
      plan: this.basePlan,
      from: '',
      period: this.period,
      campaign_code: this.campaignCode,
      trial_code: this.trialCode,
    }
  }

  getAddOnParams() {
    return {
      ...this.eventTrackItemInfo,
      type: this.flowType,
      plan: this.basePlan,
      subPlan: 'newsubs',
      from: '',
      period: this.period,
      campaign_code: this.campaignCode,
      trial_code: this.trialCode,
    };
  }

  getTrail2PaidParams() {
    return {
      ...this.eventTrackItemInfo,
      type: this.flowType,
      subPlan: '',
      oldPlanCode: this.productEntryData?.oldPlanCode,
      campaign_code: this.campaignCode,
      trial_code: this.trialCode,
    };
  }

  getLink() {
    shouldImplement();
  }

  getOptions() {
    shouldImplement();
  }

  getCurrentParams() {
    shouldImplement();
  }
}
